/** Append a speech recognition chunk to existing textarea value. */
export default function appendTranscript(current, chunk) {
  const base = String(current ?? "");
  const text = String(chunk ?? "").trim();
  if (!text) return base;
  if (!base) return text;
  const needsSpace = !/[\s\n]$/.test(base);
  return `${base}${needsSpace ? " " : ""}${text}`;
}
